import { render, staticRenderFns } from "./HelpModal.vue?vue&type=template&id=b4d1a1c4&scoped=true&"
import script from "./HelpModal.vue?vue&type=script&lang=ts&"
export * from "./HelpModal.vue?vue&type=script&lang=ts&"
import style0 from "./HelpModal.vue?vue&type=style&index=0&id=b4d1a1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d1a1c4",
  null
  
)

export default component.exports